import React,{ Suspense, lazy } from 'react';
import { Switch } from "react-router-dom";

import Spinner from '../components/Spinner';

import CustomerLayout from "../services/CustomerLayout";
import CustomerRoute from "../services/CustomerRoute";

const Dashboard = lazy(() => import('../screens/customers/Dashboard'));
const Transaction = lazy(() => import('../screens/customers/Transactions'));
const FundWallet = lazy(() => import('../screens/customers/FundWallet'));
const Profile = lazy(() => import('../screens/customers/Profile'));
const ChangePassword = lazy(() => import('../screens/customers/ChangePassword'));
const Beneficiaries = lazy(() => import('../screens/customers/Beneficiaries'));
const TopUpHistory = lazy(() => import('../screens/customers/TopUpHistory'));
const SignOut = lazy(() => import('../screens/SignOut'));

const Customer = (props) => {
  return (
    <Suspense fallback={<Spinner/>}>
      <Switch>
        <CustomerRoute
          exact={true}
          path="/dashboard"
          component={Dashboard}
          Layout={CustomerLayout}
          {...props}
        />
        <CustomerRoute
          exact={true}
          path="/transactions"
          component={Transaction}
          Layout={CustomerLayout}
          {...props}
        />
        <CustomerRoute
          exact={true}
          path="/wallet"
          component={FundWallet}
          Layout={CustomerLayout}
          {...props}
        />
        <CustomerRoute
          exact={true}
          path="/profile"
          component={Profile}
          Layout={CustomerLayout}
          {...props}
        />
        <CustomerRoute
          exact={true}
          path="/update-password"
          component={ChangePassword}
          Layout={CustomerLayout}
          {...props}
        />
        <CustomerRoute
          exact={true}
          path="/beneficiaries"
          component={Beneficiaries}
          Layout={CustomerLayout}
          {...props}
        />
        <CustomerRoute
          exact={true}
          path="/topup-history"
          component={TopUpHistory}
          Layout={CustomerLayout}
          {...props}
        />
        <CustomerRoute
          exact={true}
          path="/signout"
          component={SignOut}
          Layout={CustomerLayout}
          {...props}
        />
      </Switch>
    </Suspense>
  )
}

export default Customer;